// extracted by mini-css-extract-plugin
module.exports = {"table":"KcvuE","fill":"AQLIj","small":"m+IB+","medium":"Dgasv","large":"J8YIE"};